/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Feature_Orgs_NameInputs */

const en_marketing_feature_orgs_name = /** @type {(inputs: Marketing_Feature_Orgs_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizations`)
};

const es_marketing_feature_orgs_name = /** @type {(inputs: Marketing_Feature_Orgs_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizaciones`)
};

const fr_marketing_feature_orgs_name = /** @type {(inputs: Marketing_Feature_Orgs_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisations`)
};

/**
* | output |
* | --- |
* | "Organizations" |
*
* @param {Marketing_Feature_Orgs_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_feature_orgs_name = /** @type {((inputs?: Marketing_Feature_Orgs_NameInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Feature_Orgs_NameInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_feature_orgs_name(inputs)
	if (locale === "es") return es_marketing_feature_orgs_name(inputs)
	return fr_marketing_feature_orgs_name(inputs)
});